"use strict";
var React = require("react");
var Modal = require("react-bootstrap").Modal;
var closeButton = require("react-bootstrap").closeButton;
var Button = require("react-bootstrap").Button;
var ButtonToolbar = require("react-bootstrap").ButtonToolbar;
var InventoryActions = require("../../actions/InventoryActions");

var SellInventoryItemFormModal = React.createClass({
  onSubmit(event) {
    event.preventDefault();
    const newItem = this.props.equipment;
    newItem.status = '48df1cf3-481b-4daf-a68d-3b5abde83470';
    InventoryActions.editItem(newItem);
    this.props.onHide();
  },
  render: function() {
    return (
      <Modal {...this.props} bsStyle="primary" animation={true}>
        <Modal.Body>
          <div id="deleteInventoryItemModal" className="modal-body">
            <h3>Viltu senda vöruna á sölutorgið?</h3>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <Button className="btn-success" onClick={this.onSubmit} type="submit">Já</Button>
            <Button onClick={this.props.onHide}>Nei</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
});

module.exports = SellInventoryItemFormModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/SellInventoryItemFormModal.js